import authServices from '@/modules/Auth/auth-services'
import { useMutation } from '@tanstack/react-query'

export const useGetPatientProfileData = () => {
  return useMutation({
    mutationFn: () => authServices.getUserData(),
    retry: false,
  })
}
